import { Product, ProductAttribute } from '@/api/ProductApi';
import { Accessory } from '@/api/AccessoryApi';
import { UUID } from './types';
import {
	ComponentAttribute,
	ComponentAttributeValue,
} from '@/api/ComponentApi';
import { AccessoryCategory } from '@/api/AccessoryCategoryApi';

export interface ComponentAttributeWithAvailability
	extends Omit<ComponentAttribute, 'componentAttributeValues'> {
	componentAttributeValues: ComponentAttributeValueWithAvailability[];
	disabled: boolean;
}

export interface CreatorAccessory extends Accessory {
	disabled: boolean;
}

export interface CreatorAccessoryCategory extends AccessoryCategory {
	accessories: CreatorAccessory[];
}

export interface ComponentAttributeValueWithAvailability
	extends ComponentAttributeValue {
	disabled: boolean;
}

export interface DimensionObject {
	width: number;
	height: number;
}

export interface CreatorState {
	clientId: UUID | null;
	product: Product | null;
	quantity: number;
	availableAttributes: Record<UUID, ComponentAttributeWithAvailability[]>;
	availableAccessories: CreatorAccessoryCategory[];
	chosenProductAttributes: Record<UUID, Record<UUID, ProductAttribute>>;
	chosenAccessories: Record<UUID, Accessory>;
	dimensionConfigValues: Record<string, DimensionObject>;
	options: CreatorOptions;
}

export enum CreatorStepType {
	DIMENSIONS = 'dimensions',
	COMPONENTS = 'components',
	ACCESSORIES = 'accessories',
	SUMMARY = 'summary',
}

export interface CreatorStep {
	order: number;
	label: string;
	componentId?: UUID;
	disabled: boolean;
	type: CreatorStepType;
}

export interface CreatorOptions {
	currentStep: number;
	availableSteps: CreatorStep[];
}
